<template>
  <div>
    <!-- <Breadcrumb :links="breadcrumbs" /> -->
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link to="/reportsList" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("system.label.CreateReport") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <div class="vx-row">
        <vx-card title card-border>
          <h4>{{ $t("system.label.ReportDetails") }}</h4>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="vx-row">
                <div
                  class="vx-col md:w-1/4 check-box"
                  style="margin-left: 20px"
                >
                  <vs-checkbox
                    class="float-right mt-5"
                    v-model="Reports.useReport"
                    >{{ $t("system.label.UserReportUI") }}</vs-checkbox
                  >
                </div>
                <div
                  class="vx-col md:w-1/4 check-box"
                  style="margin-left: 30px"
                >
                  <vs-checkbox class="mt-5" v-model="Reports.coreReport"
                    >{{ $t("system.label.isScheduled") }}
                  </vs-checkbox>
                </div>
              </div>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('system.label.ReportName')"
              >
                <vs-input
                  :label="$t('system.label.ReportName')"
                  class="w-full mb-2 mt-3 font-semibold starlabel"
                  v-model="Reports.reportName"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('system.label.ReportCategory')"
              >
                <vs-input
                  :label="$t('system.label.ReportCategory')"
                  class="w-full mb-2 mt-4 font-semibold starlabel"
                  v-model="Reports.reportCategory"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>

            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label" style="margin-top: -8px">
                <small class="date-label ml-4 mt-16 font-semibold"
                  >{{ $t("system.label.ReportType")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('system.label.ReportType')"
                >
                  <v-select
                    label="item"
                    :options="ReportsData.allowedReportTypes"
                    v-model="Reports.reportType"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2 mt-16"
                  >
                    <template v-slot:option="option">{{
                      option.item
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="w-full ml-6 mb-2 mt-5">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("system.label.Description")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('system.label.Description')"
                >
                  <vs-textarea
                    class="w-full mb-2 font-semibold"
                    v-model="Reports.description"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="w-full ml-6 mb-2 font-semibold">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold">{{
                  $t("system.label.Sql")
                }}</small>
                <vs-textarea
                  class="w-full mb-2 font-semibold"
                  v-model="Reports.reportSql"
                />
              </div>
            </div>
          </div>
          <div class="vx-row ml-3 mt-6">
            <h4>{{ $t("system.label.ReportParameters") }}</h4>
          </div>
          <div class="vx-row ml-3 mt-4">
            <div class="w-1/2">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold">{{
                  $t("system.label.AllowedParameters")
                }}</small>
                <v-select
                  label="parameterName"
                  :options="ReportsData.allowedParameters"
                  v-model="Reports.parameterName"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2"
                >
                </v-select>
              </div>
            </div>

            <div class="vx-col md:w-1/4 ml-4 mt-4" style="margin: 0.5rem 0">
              <vs-button @click="addParameter"
                >{{ $t("system.label.CreateParameter") }}
              </vs-button>
            </div>
          </div>
          <div class="vx-row ml-3 mt-6">
            <div class="w-full">
              <div class="block overflow-x-auto">
                <table class="table w-full table-bordered table-striped">
                  <tr>
                    <td>
                      <b>{{ $t("system.label.Parameter") }}</b>
                    </td>
                    <td>
                      <b>{{
                        $t("system.label.ParameterNamePassedToPentaoh")
                      }}</b>
                    </td>
                    <td class="tHeadCenter">
                      <b>{{ $t("system.label.Action") }}</b>
                    </td>
                  </tr>
                  <tr v-for="(Reports, index) in reportParameters" :key="index">
                    <td>{{ Reports.parameterName }}</td>
                    <td>
                      <vs-input
                        class="w-full mb-2 font-semibold starlabel"
                        :placeholder="$t('system.label.Enter_service_Description')"
                        v-model="Reports.reportParameterName"
                      />
                    </td>

                    <vs-td class="whitespace-no-wrap">
                      <div class="container_img">
                        <button
                          @click="removeItem(index)"
                          class="bGNone mt-4 border-none view_editTable_btn"
                        >
                          <feather-icon
                            icon="TrashIcon"
                            :title="$t('system.label.Delete')"
                            svgClasses="w-5 h-5 text-danger stroke-current cursor"
                            class="icon_row"
                          />
                        </button>
                      </div>
                    </vs-td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="resetForm"
            >{{ $t("system.label.Reset") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="createreports"
            >{{ $t("system.label.submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";

const ReportsEmptyObj = {
  reportName: "",
  reportType: "",
  reportCategory: "",
  description: "",
  reportSql: "",
  coreReport: false,
  useReport: false,
  parameterName: "",
};

export default {
  data() {
    return {
      Reports: ReportsEmptyObj,
      reportParameters: [],
      warningPopup: false,
      warningText: "",
      statuses: ["Table", "Pentaha", "Chart"],
      errorMessage: "",
    };
  },
  components: {
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapState({
      ReportsData: (state) => state.manageReport.CreateViewReportTemplate,
    }),
    breadcrumbs() {
      return [
        {
          name: this.$t("system.label.ManageReports"),
          to: "/reportsList",
        },
        { name: this.$t("system.label.CreateReport"), to: "/" },
      ];
    },
  },
  methods: {
    removeItem(i) {
      this.reportParameters.splice(i, 1);
    },
    addParameter() {
      try {
        let createParameter = {
          parameterName: this.Reports.parameterName.parameterName,
          parameterId: this.Reports.parameterName.id,
          reportParameterName: "",
        };
        if (this.Reports.parameterName !== "") {
          this.reportParameters = [...this.reportParameters, createParameter];
        }
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createreports() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      try {
        delete this.Reports.allowedReportTypes;
        delete this.Reports.allowedReportSubTypes;
        delete this.Reports.allowedParameters;
        delete this.Reports.data;
        delete this.Reports.coreReport;
        delete this.Reports.parameterName;
        //   delete this.Reports.useReport;
        if (this.reportParameters.length > 0) {
          this.Reports.reportParameters = this.reportParameters;
        } else {
          delete this.Reports.reportParameters;
        }
        await this.$store.dispatch(
          "manageReport/createreportsAction",
          this.Reports
        );
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Manage Report Created Successfully!",
          type: "success",
        });
        this.$router.push("/reportsList");
        this.resetForm();
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    async getReportsTemplateData() {
      try {
        await this.$store.dispatch(
          "manageReport/setReportsTemplateData",
          this.id
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    cancel() {
      this.$router.push("/reportsList");
    },

    resetForm() {
      this.Reports = ReportsEmptyObj;
      this.Reports.reportName = "";
      this.Reports.reportType = "";
      this.Reports.reportCategory = "";
      this.Reports.description = "";
      this.Reports.reportSql = "";
      this.Reports.coreReport = "";
      this.Reports.useReport = "";
      this.reportParameters = [];
      this.Reports.parameterName = "";
      this.$refs.observer.reset();
    },
  },
  watch: {},
  created() {},
  mounted() {
    this.resetForm();
    this.id = this.$route.params.id;
    this.getReportsTemplateData();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
.check-box {
  width: 36% !important;
}
</style>
